import React from 'react';
import CardSimple from 'screens/components/basic/CardSimple';

const Campaign = () => {
    return(
        <div id="campaign-rules">
            <br />
            <div>
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>Campaign Rules</h2>
                        <p>There are 2 types of campaigns in TechPOS</p>
                        <ul>
                            <li><strong>Recurrent Sale:</strong>: This is a regular sale (e.g. 10% discount every Monday, $5 off every flower Thursday, etc)</li>
                            <li><strong>One-Time Sale:</strong> This is intended for big sales happening for a short amount of time (e.g. Black Friday, Boxing Day, etc)</li>
                        </ul>
                        <p>You can have a recurrent sale and an one-time sale happening at the same time for the same products. In this case, the discount the discount applied to the product will be the one-time sale discount. You can have 2 or more recurrent
                        sales happening at the same time as long as they affect different products OR affect the same product on
                        different days. The same rule applies for one-time sales happening at the same time.</p>
                        <p><b>Campaign only applies to items available for sale (in Store Warehouse)</b></p>
                    </div>
                </CardSimple>
            </div>
            <div id="campaign-create">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to Create a Campaign?</h2>
                        <ul>
                            <li>Go to Menu > Pricing > Campaign</li>
                            <img src="http://techpos.ca/support-images/Campaign/Campaign-1.png" />
                            <li>Click on Add New Campaign</li>
                            <img src="http://techpos.ca/support-images/Campaign/Campaign-2.png" />
                            <li>Fill the information. Click on Save</li>
                            <img src="http://techpos.ca/support-images/Campaign/Campaign-3.png" />
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="campaign-edit">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>How to Edit a Campaign?</h2>
                        <ul>
                            <li>Go to Menu > Pricing > Campaign</li>
                            <img src="http://techpos.ca/support-images/Campaign/Campaign-1.png" />
                            <li>Locate the campaign you want to edit. Click on Edit</li>
                            <img src="http://techpos.ca/support-images/Campaign/Campaign-4.png" />
                            <li>Edit the information an click on Save</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
            <div id="campaign-cannot-add">
                <br />
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>I Can't Add a Campaign</h2>
                        <p><b>Make sure that the Campaign follows the rules on the section Campaign > Rules in this document.</b></p>
                        <p>To find the campaign that is creating the problem:</p>
                        <ul>
                            <li>Go to Menu > Pricing > Campaign</li>
                            <li>Take a look at the campaigns that are conflicting in starting date and days</li>
                            <li>Edit the necessary campaigns</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
        </div>
    )
}

export default Campaign;